<template>
  <transition name="modal">
    <div class="modal-mask text-left">
      <div class="modal-wrapper">
        <div class="modal-container child">
          <div class="modal-body">
            <div class="form-group">
              <div class="info">{{ msg }}</div>
            </div>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                class="modal-default-button btn btn-default"
                @click="closeAlert()">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import EventBus from '../services/eventBus.js';

export default {
	// eslint-disable-next-line vue/require-prop-types
	props: ['msg',],
	data() {
		return {
			path: '',
			hasErrors: false,
		};
	},
	methods: {
		closeAlert() {
			EventBus.$emit('closeAlert');
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ModalAlert.vue